<div *ngIf="terminal" class="terminal-context">
  <p class="terminal-name">
    <span class="context-label">{{ 'components.terminalContext.openTerminal' | translate }}:</span>
    <strong>{{ terminal.name || ('components.terminalContext.unknownTerminal' | translate) }}</strong>
  </p>
  <p *ngIf="serviceNames" class="terminal-services">
    <span class="context-label">{{ 'components.terminalContext.services' | translate }}:</span>
    <span>{{ serviceNames }}</span>
  </p>
</div>
